import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import {
  LocationStrategy,
  HashLocationStrategy,
  registerLocaleData
} from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCALE_ID } from '@angular/core';
import LocaleEsPe from '@angular/common/locales/es-PE';
registerLocaleData(LocaleEsPe);

import { AppComponent } from './app.component';
import { AppComponents } from './@app/components';
import { PrimeNgModules } from './@prime-ng/primeng.module';
import { AppRoutingModule } from './app-routing.module';
import { AuthComponents } from './auth/components';
import { AmigaPymeModule } from './@amiga-pyme/ami-pyme.module';
import { PagesComponents } from './pages/pages.module';
import { CacheInterceptor } from './middleware/cache/cache.interceptor';
import { AuthGuard } from './middleware/auth/auth-guard.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { NgApexchartsModule } from 'ng-apexcharts';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ProgressSpinnerModule,
    ...PrimeNgModules,
    AmigaPymeModule,
    NgApexchartsModule
  ],
  declarations: [
    AppComponent,
    ...AuthComponents,
    ...AppComponents,
    ...PagesComponents
  ],
  providers: [
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptor,
      multi: true
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: LOCALE_ID, useValue: 'es-PE' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
